import ProductTagDetail from './ProductTagDetail';

export default ProductTagDetail;



// WEBPACK FOOTER //
// ./src/scenes/ProductTag/ProductTagDetail/index.ts